(function () {
  'use strict';
  if (window.__swBisLoaded) return;
  window.__swBisLoaded = true;

  // In-stock -> sold out: the back-in-stock form drops down with a CSS animation (sw-styles.css .sw-bis--enter),
  // no GSAP. No animation with reduced motion.
  function dropIn(bis) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var height = bis.scrollHeight;
    if (!height) return;
    bis.style.setProperty('--sw-bis-h', height + 'px');
    bis.classList.add('sw-bis--enter');
    bis.addEventListener('animationend', function done() {
      bis.removeEventListener('animationend', done);
      bis.classList.remove('sw-bis--enter');
      bis.style.removeProperty('--sw-bis-h');
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mut) {
      var oldBB = null; // removed <buy-buttons>
      var newBB = null; // added  <buy-buttons>

      mut.removedNodes.forEach(function (n) {
        if (n.tagName === 'BUY-BUTTONS') oldBB = n;
      });
      mut.addedNodes.forEach(function (n) {
        if (n.tagName === 'BUY-BUTTONS') newBB = n;
      });

      // buy-buttons was swapped (variant change); sold out -> in stock stays instant
      if (oldBB && newBB) {
        var oldBis = oldBB.querySelector('.sw-bis:not([hidden])');
        var newBis = newBB.querySelector('.sw-bis:not([hidden])');
        if (!oldBis && newBis) dropIn(newBis);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Sync BIS data after variant change
  document.addEventListener('variant:change', function (e) {
    var formId  = e.detail.formId;
    var variant = e.detail.variant;

    document.querySelectorAll('.sw-bis[data-form-id="' + formId + '"]').forEach(function (bisEl) {
      bisEl.dataset.variantId = variant ? variant.id : '';
      var emailEl = bisEl.querySelector('.sw-bis__email');
      if (emailEl) emailEl.value = '';
      bisEl.querySelectorAll('.sw-bis__message').forEach(function (m) { m.hidden = true; });
    });
  });

  // Sticky BIS scroll-to button
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bis-scroll]')) return;
    var form = document.querySelector('.sw-bis:not(.sw-bis--sticky)');
    if (!form) return;
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var email = form.querySelector('.sw-bis__email');
    if (!email) return;
    email.focus();
    // Re-scroll after iOS keyboard + autofill bar appears and shrinks the viewport
    if (window.visualViewport) {
      var onKeyboard = function () {
        window.visualViewport.removeEventListener('resize', onKeyboard);
        email.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      window.visualViewport.addEventListener('resize', onKeyboard);
      setTimeout(function () {
        window.visualViewport.removeEventListener('resize', onKeyboard);
      }, 1500);
    }
  });

  // BIS form submit
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sw-bis__btn');
    if (!btn) return;

    var bisEl     = btn.closest('.sw-bis');
    var emailEl   = bisEl.querySelector('.sw-bis__email');
    var headingEl = bisEl.querySelector('.sw-bis__heading');
    var successEl = bisEl.querySelector('.sw-bis__message--success');
    var errorEl   = bisEl.querySelector('.sw-bis__message--error');
    var key       = bisEl.dataset.klaviyoKey;
    var variantId = bisEl.dataset.variantId;
    var email     = (emailEl.value || '').trim();
    var hpEl      = bisEl.querySelector('.sw-bis__hp');

    if (successEl) successEl.hidden = true;
    if (errorEl) errorEl.hidden = true;

    if (hpEl && hpEl.value !== '') return;
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { emailEl.focus(); return; }
    if (!variantId) {
      if (errorEl) { errorEl.textContent = 'Could not identify variant. Please refresh and try again.'; errorEl.hidden = false; }
      return;
    }

    if (!key) {
      if (errorEl) { errorEl.textContent = 'Notifications are not configured. Please add a Klaviyo API key in theme settings.'; errorEl.hidden = false; }
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    })
      .then(function (res) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (res.ok) {
          emailEl.value = '';
          if (headingEl && successEl) {
            headingEl.textContent = successEl.textContent;
          }
          var bisRow = bisEl.querySelector('.sw-bis__row');
          if (bisRow) bisRow.hidden = true;
        } else {
          if (errorEl) errorEl.hidden = false;
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (errorEl) errorEl.hidden = false;
      });
  });
})();
